export default function filterNRFforRecData(nrfData: any, currentPid: any) {
  if (nrfData && currentPid) {
    const currentData = nrfData.filter((dataObj: any) => {
      return dataObj.payer_data.payer_id === currentPid;
    });
    return currentData[0]?.form_data;
  }
}
